import { FC } from 'react'
import { Tabs as MUITabs, TabsProps } from '@mui/material'

export const Tabs: FC<TabsProps> = props => {
  return <MUITabs {...props} />
}
